import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DisciplinesFilterList from "./DisciplinesFilterList";
import classes from "./DisciplinesPage.module.css";
import * as PathRouter from '../../../../models/PathRoute'


const DisciplinesPage = () => {
    const navigate = useNavigate();

    const selectDisciplineCB=(id)=>{
        navigate(`./${id?id:PathRouter.NEW}`);
    }

    return <div className={classes.DisciplinesPage}>
       {<DisciplinesFilterList selectDisciplineCB={selectDisciplineCB}></DisciplinesFilterList>}
    </div>
}

export default DisciplinesPage;